export enum SubscriptionCadence {
  MONTHLY = 'monthly',
  ANNUAL = 'annual',
  OTHER = 'other',
}

export const isSubscriptionCadence = (val: string): val is SubscriptionCadence =>
  Object.values(SubscriptionCadence).includes(val as SubscriptionCadence);
